/**
 * @generated SignedSource<<5d93cc0458000a4980302a88a5af1655>>
 * @relayHash bc6f9cdc44977d3c37215099319c24e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c361fbcab3aafbd16e08d0a31d2531ca6cdbac4827fed1307345a029eb69925

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { profileMenuQuery } from './profileMenuQuery.graphql';

const node: PreloadableConcreteRequest<profileMenuQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9c361fbcab3aafbd16e08d0a31d2531ca6cdbac4827fed1307345a029eb69925",
    "metadata": {},
    "name": "profileMenuQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
